module.exports = __webpack_public_path__ + "static/media/right_gain.f931ca16.png";